import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { EparakstsReturnPage } from '@/pages/agreements/ui/EparakstsReturnPage'

const eparakstsReturnSearchSchema = z.object({
  process_uuid: z.string().catch(''),
  error: z.string().optional().catch(undefined),
})

export const Route = createFileRoute('/ProcessEparaksts')({
  validateSearch: eparakstsReturnSearchSchema,
  component: EparakstsReturnPage,
})
